import { gql } from 'graphql-request';
import { graphqlClient } from '../client';
import { removeChargeFromRedux } from '@/store/actions/chargeActions';

// The GraphQL mutation for deleting a charge
const DELETE_CHARGE_MUTATION = gql`
  mutation DeleteCharge($id: ID!) {
    deleteCharge(id: $id) {
      id
      success
      message
    }
  }
`;

// Response type definition
export interface DeleteChargeResponse {
  deleteCharge: {
    id: string;
    success: boolean;
    message: string;
  };
}

/**
 * GraphQL mutation to delete a charge by ID
 * 
 * @param id The ID of the charge to delete
 * @returns Response containing success status and message
 */
export async function deleteChargeMutation(
  id: string
): Promise<DeleteChargeResponse> {
  try {
    console.log(`🔄 [GraphQL] Deleting charge ${id}`);
    
    // Execute the GraphQL mutation
    const response = await graphqlClient.request<DeleteChargeResponse>(
      DELETE_CHARGE_MUTATION,
      { id }
    );
    
    console.log('✅ [GraphQL] Charge deletion response:', response);
    
    // If deletion was successful, update the Redux store by removing the charge
    if (response && response.deleteCharge && response.deleteCharge.success) {
      try {
        // Update Redux store to remove the deleted charge
        removeChargeFromRedux(id);
        console.log('✅ [GraphQL] Charge deleted successfully, Redux store updated');
      } catch (reduxError) {
        // Don't let Redux update failures break the main flow
        console.error('⚠️ [Redux] Failed to update Redux store after charge deletion:', reduxError);
      }
    }
    
    return response;
  } catch (error) {
    console.error('❌ [GraphQL] Error deleting charge:', error);
    throw error;
  }
}
